import {featuresConstants} from "../../actions/features";

const defaultState = {};

export default function featureFlags(state = defaultState, { type, payload }) {

  switch (type){
  case featuresConstants.UPDATE_FEATURE_FLAGS:
    return {...state, ...payload};
  default:
    return state;
  }
}
